import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useGetResolvedFlagsQuery } from '../../store/api/featureFlagsApi';

interface Props {
  flagKey: string;
  children: React.ReactNode;
}

/**
 * Bloquea el acceso a una ruta si su feature flag está deshabilitada.
 * Si el flag no existe en la base, fail-open (permite acceso).
 * Mientras carga los flags muestra un spinner.
 */
export function FeatureFlagGuard({ flagKey, children }: Props) {
  const { data, isLoading } = useGetResolvedFlagsQuery();

  if (isLoading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Si el flag no está definido → fail-open
  if (!(flagKey in data)) return <>{children}</>;

  // Flag deshabilitado → redirect a dashboard
  if (data[flagKey] === false) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
